/** @jsx jsx */
import * as React from "react";
import { css, InterpolationWithTheme, jsx } from "@emotion/core";
import { IDayEpochInfo } from "../../models/util/IDayEpochInfo";
import { interventionsSummaryStyles } from "../../styles/Interventions/interventionsSummary";
import { interventionsDailyViewStyles } from "../../styles/Interventions/interventionsDailyView";
import { IFetchScheduledInterventionsResponse, INTERVENTIONS_STATUS } from "../../models/IFetchScheduledInterventions";
import { Dictionary } from "lodash";
import { StatusIndicator } from "./StatusIndicator";
import { InterventionDailyViewMobile } from "./mweb/InterventionDailyView/InterventionDailyViewMobile";
import { Card } from "../common/Card";





interface IIntervantionsDailyViewProps {
    dateList: IDayEpochInfo[];
    data: Dictionary<IFetchScheduledInterventionsResponse[]>;
    onDailyViewFwd(): void;
    onDailyViewBack(): void
    isMobile: boolean;
}

interface IIntervantionsDailyViewState {

}



export class InterventionsDailyView extends React.Component<IIntervantionsDailyViewProps, IIntervantionsDailyViewState> {
    constructor(props: IIntervantionsDailyViewProps) {
        super(props);
    }

    getDataForCurrentDate = (currentRowData: IFetchScheduledInterventionsResponse[], startEpoch: number, endEpoch: number): IFetchScheduledInterventionsResponse => {
        let dataForCurrentDate: IFetchScheduledInterventionsResponse = null;
        currentRowData.forEach((data) => {
            const currentDataDate = data.date;
            if (currentDataDate >= startEpoch && currentDataDate < endEpoch) {
                dataForCurrentDate = data;
            }
        });
        return dataForCurrentDate;
    }

    getIconImageUrl = (scheduledPlanCategory: string): string => {
        let iconImageUrl: string = "/images/medication.svg";

        if (scheduledPlanCategory === "MEAL") {
            iconImageUrl = "/images/food.svg"
        } else if (scheduledPlanCategory === "WORKOUT") {
            iconImageUrl = "/images/excercise.svg"
        } else if (scheduledPlanCategory === "MEDICINE") {
            iconImageUrl = "/images/medication.svg"
        } else if (scheduledPlanCategory === "MIND" || scheduledPlanCategory === "SLEEP") {
            iconImageUrl = "/images/minddful.svg"
        }
        return iconImageUrl;
    }


    render() {
        const { dateList, data, onDailyViewBack, onDailyViewFwd, isMobile } = this.props;
        return (
            <React.Fragment>
                {
                    isMobile ? <InterventionDailyViewMobile
                        getDataForCurrentDate={this.getDataForCurrentDate}
                        getIconImageUrl={this.getIconImageUrl}
                        {...this.props}
                    /> : <div css={interventionsSummaryStyles.summaryCardWrapper}>
                        <Card customCss={interventionsSummaryStyles.wrapperCard} showShadow>
                            <div css={interventionsSummaryStyles.summaryContainer}>
                                <div css={interventionsSummaryStyles.cardHeaderText}>Daily View</div>
                                <div css={{ marginLeft: 17 }}>
                                    <table css={interventionsDailyViewStyles.table}>
                                        <thead>
                                            <tr css={interventionsDailyViewStyles.tableHeader}>
                                                <React.Fragment>
                                                    <td><div>Activity List</div></td>
                                                    {
                                                        dateList && dateList.map((date, index) => {

                                                            if (index === 0 || index === (dateList.length - 1)) {
                                                                const iconStyle: InterpolationWithTheme<any> = index === 0 ? {
                                                                    // position: "relative",
                                                                    // right: 20,
                                                                    cursor: "pointer"
                                                                } : {
                                                                    // position: "relative",
                                                                    // left: 70,
                                                                    transform: "rotate(180deg)",
                                                                    cursor: "pointer"
                                                                };

                                                                const clickHandler = index === 0 ? onDailyViewBack : onDailyViewFwd;
                                                                return (<React.Fragment>
                                                                    {index === 0 && <td css={interventionsDailyViewStyles.centerAlign}>
                                                                        <img src="/images/back-frwd.svg" css={iconStyle} onClick={clickHandler} />
                                                                    </td>}<td css={interventionsDailyViewStyles.centerAlign}>
                                                                        <div css={{ display: "inline-block" }}>{date.display}</div>
                                                                    </td>
                                                                    {index === dateList.length - 1 && <td css={interventionsDailyViewStyles.centerAlign}>
                                                                        <img src="/images/back-frwd.svg" css={iconStyle} onClick={clickHandler} />
                                                                    </td>}
                                                                </React.Fragment>)
                                                            }
                                                            return (<td css={interventionsDailyViewStyles.centerAlign}><div>{date.display}</div></td>)
                                                        })
                                                    }
                                                </React.Fragment>
                                            </tr>
                                        </thead>
                                        <tbody css={interventionsDailyViewStyles.rowsWrapper}>
                                            <tr>
                                                <td colSpan={dateList ? (dateList.length + 2) : 9}>
                                                    <div css={{ ...interventionsDailyViewStyles.divider as any, margin: "10px 0" }}></div>
                                                </td>
                                            </tr>
                                            {Object.keys(data).map(key => <React.Fragment>

                                                <tr>
                                                    {
                                                        dateList && dateList.map((date, index) => {
                                                            let dataForCurrentDate = this.getDataForCurrentDate(data[key], date.startEpoch, date.endEpoch);
                                                            const itemName: string = data[key] && data[key][0] && data[key][0].lineItem.modifiedInterventionText;
                                                            const scheduledPlanCategory: string = data[key] && data[key][0] && data[key][0].scheduledPlanCategory;
                                                            const itemIconUrl: string = this.getIconImageUrl(scheduledPlanCategory);
                                                            if (index === 0) {
                                                                return (
                                                                    <React.Fragment>
                                                                        <td css={interventionsDailyViewStyles.tableCols}>
                                                                            <div css={{ display: "flex" }}>
                                                                                <img src={itemIconUrl} css={interventionsDailyViewStyles.iterventionNameIcon} />
                                                                                <div css={interventionsDailyViewStyles.iterventionNameText}>{itemName}</div>
                                                                            </div>
                                                                        </td>
                                                                        <td></td>
                                                                        <td css={{ ...interventionsDailyViewStyles.tableCols as any, ...interventionsDailyViewStyles.centerAlign as any }}>
                                                                            <StatusIndicator status={dataForCurrentDate && dataForCurrentDate.status} />
                                                                        </td>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                            return (
                                                                <React.Fragment>
                                                                    <td css={{ ...interventionsDailyViewStyles.tableCols as any, ...interventionsDailyViewStyles.centerAlign as any }}>
                                                                        <StatusIndicator status={dataForCurrentDate && dataForCurrentDate.status} />
                                                                    </td>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    }
                                                    <td></td>
                                                </tr>
                                            </React.Fragment>)
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div css={interventionsDailyViewStyles.divider}></div>
                            <div css={interventionsDailyViewStyles.legendContainer}>
                                {
                                    Object.keys(INTERVENTIONS_STATUS).map(status => <div css={interventionsDailyViewStyles.legend}>
                                        <StatusIndicator status={status as INTERVENTIONS_STATUS} height={15} />
                                        <div css={interventionsDailyViewStyles.legendText}>{status.toLowerCase()}</div>
                                    </div>)
                                }
                            </div>
                        </Card>
                    </div>
                }
            </React.Fragment>)

    }
}